import englishMessages from './en/en.json';
import frenchMessages from './fr/fr.json';
export const messages: any = {
	en: englishMessages,
	fr: frenchMessages,
};
